import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Slider from "react-slick"; // Import the slider library
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css"; // Slick CSS
import "slick-carousel/slick/slick-theme.css"; // Slick theme CSS
import "./OrderCard.scss";
import DynamicForm from "../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../services/api/API";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import Loader from "../../../customComponents/CustomLoader";
import OrderCardLoader from "../../../customComponents/CustomLoaderOrderCard";

const OrderCard = ({ orders }) => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [modalPosition, setModalPosition] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [showWarrantyInputs, setshowWarrentyInputs] = useState(false);
  const authToken = localStorage.getItem("authToken");
  const [extWarrantyOptions, setextWarrantyOptions] = useState([]);

  const [selectedVariantId, setSelectedVariantId] = useState(null);

  const [visibleOrders, setVisibleOrders] = useState(10);
  const [loading, setIsLoading] = useState(false);
  const observerRef = useRef(null);

  const loadMoreOrders = () => {
    if (!loading) {
      setIsLoading(true); // Show loader
      setTimeout(() => {
        setVisibleOrders((prev) => prev + 5); // Load 5 more orders
        setIsLoading(false); // Hide loader after data is updated
      }, 1000); // Simulating API delay
    }
  };

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        const lastOrder = entries[0];
        if (lastOrder.isIntersecting) {
          loadMoreOrders();
        }
      },
      { threshold: 1.0 }
    );

    if (document.getElementById("last-order")) {
      observerRef.current.observe(document.getElementById("last-order"));
    }

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [visibleOrders]);

  console.log("orders");

  const navigate = useNavigate();
  const assignButtonRef = useRef(null);

  const handleOrderNowClick = (order) => {
    console.log(order, "orderssss");
    if (assignButtonRef.current) {
      // Check if ref is not null
      const rect = assignButtonRef.current.getBoundingClientRect();
      setModalPosition({
        top: rect.top + window.scrollY - 100,
        left: rect.left + window.scrollX,
      });
    }
    setSelectedVariantId(order);
    setShowModal(true); // Show the modal after setting position
    // fetchVariantBasedDetails();
    fetchExtWarrantyOptions();
  };

  const handleModalClose = () => {
    setShowModal(false);
    setshowWarrentyInputs(false);
  };

  const handleDraft = async (formData) => {
    // const errors = {};
    // let isValid = true;

    // // Form validation
    // VariantInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   }
    // });

    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    const errors = {};
    let isValid = true;

    VariantInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("formData", formData);
    const formatDateToDDMMYYYY = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Determine the payload based on selectedVariantId.itemtype
    let payload;
    const poExpectedDate = formData?.po_expected_date
      ? formatDateToDDMMYYYY(formData.po_expected_date)
      : null; // Format the date or set it to null if not provided
    if (
      selectedVariantId?.itemtype === "A" ||
      selectedVariantId?.itemtype === "S"
    ) {
      payload = {
        item_id: selectedVariantId.item_id,
        quantity: Number(formData.quantity) || 0, // Default to 0 if not provided
        itemtype: selectedVariantId?.itemtype, // Dynamically set itemtype
        is_order_accepted: 6,
        po_expected_date: poExpectedDate,
      };
    } else {
      payload = {
        variant_id: formData.variant,
        quantity: Number(formData.quantity) || 0, // Default to 0 if not provided
        itemtype: "V", // Assuming itemtype for "Vehicle"
        is_order_accepted: 6,
        po_expected_date: poExpectedDate,
      };
    }

    // Log the final payload
    console.log("payload", payload);

    try {
      setIsLoading(true);

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to create this draft?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false);
        return;
      }

      // Perform API call to submit form data
      const response = await axiosInstance.post(
        "/podraftdetails/createPo",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("API Response:", response.data);

      // Success message after API call
      Swal.fire({
        title: "Success!",
        text: "Draft Created successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setShowModal(false);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      const errorMessage = error?.response?.data?.message;

      // Error alert in case of failure
      Swal.fire({
        title: "Error!",
        text: errorMessage
          ? errorMessage
          : "Failed to create the order. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    // const errors = {};
    // let isValid = true;

    // // Form validation
    // VariantInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   }
    // });

    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    const errors = {};
    let isValid = true;

    VariantInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("formData", formData);

    const formatDateToDDMMYYYY = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Determine the payload based on selectedVariantId.itemtype
    let payload;

    const poExpectedDate = formData?.po_expected_date
      ? formatDateToDDMMYYYY(formData.po_expected_date)
      : null; // Format the date or set it to null if not provided

    if (
      selectedVariantId?.itemtype === "A" ||
      selectedVariantId?.itemtype === "S"
    ) {
      payload = {
        item_id: selectedVariantId.item_id,
        quantity: Number(formData.quantity) || 0, // Default to 0 if not provided
        itemtype: selectedVariantId?.itemtype, // Dynamically set itemtype
        po_expected_date: poExpectedDate,
      };
    } else {
      payload = {
        variant_id: formData.variant,
        quantity: Number(formData.quantity) || 0, // Default to 0 if not provided
        itemtype: "V", // Assuming itemtype for "Vehicle"
        po_expected_date: poExpectedDate,
      };
    }

    // Log the final payload
    console.log("payload", payload);

    try {
      setIsLoading(true);

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to create this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false);
        return;
      }

      // Perform API call to submit form data
      const response = await axiosInstance.post(
        "/purchaseorder/createsingleorder",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("API Response:", response.data);

      // Success message after API call
      Swal.fire({
        title: "Success!",
        text: "Order Created successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setShowModal(false);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      const errorMessage = error?.response?.data?.message;

      // Error alert in case of failure
      Swal.fire({
        title: "Error!",
        text: errorMessage
          ? errorMessage
          : "Failed to create the order. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  useEffect(() => {
    // fetchVariantOptions();
    // fetchVariantBasedDetails();
    fetchExtWarrantyOptions();
  }, [formData?.variant]);

  useEffect(() => {
    if (showModal) {
      // fetchVariantBasedDetails();
    }
  }, [showModal]);

  const fetchExtWarrantyOptions = async (variantId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/extendedwarranty/ddlextendedwarranty",
        {
          variant_id: selectedVariantId,
          itemtype: "Vehicle",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setextWarrantyOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const [warrantyTypeData, setWarrantyTypeData] = useState([]);
  const [warrantycategory, setWarrantyCategory] = useState([]);

  useEffect(() => {
    warrantyType();
    warrantyCategory();
  }, []);
  const warrantyCategory = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantycategory",
        {}, // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data.data.data;
      const warrantycategoryoptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyCategory(warrantycategoryoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const warrantyType = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantytype",
        {}, // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data.data.data;
      const warrantyTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyTypeData(warrantyTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const VariantInputs = [
    ...(selectedVariantId?.itemtype === "A" ||
    selectedVariantId?.itemtype === "S"
      ? [
          {
            name: "item_name",
            label: "Item Name",
            placeholder: "Item Name",
            type: "text",
            disabled: true,
            gridClass: "col-lg-3",
          },
        ]
      : []),
    ...(selectedVariantId?.itemtype === "A" ||
    selectedVariantId?.itemtype === "S"
      ? [
          {
            name: "item_category_name",
            label: "Item Category Name",
            placeholder: "Item Category Name",
            type: "text",
            disabled: true,
            gridClass: "col-lg-3",
          },
        ]
      : []),
    {
      name: "variant",
      label: "Variant",
      placeholder: "Select...",
      type: "dropdown",
      disabled: true,
      options: variantOptions,
      gridClass: "col-lg-3",
    },
    {
      name: "model_name",
      label: "Model",
      placeholder: "model",
      type: "text",
      disabled: true,
      gridClass: "col-lg-3",
    },
    {
      name: "color",
      label: "Color",
      placeholder: "Color",
      type: "text",
      disabled: true,
      gridClass: "col-lg-3",
    },
    {
      name: "warranty",
      label: "Warranty",
      placeholder: "Warranty",
      type: "text",
      disabled: true,
      gridClass: "col-lg-3",
    },
    {
      name: "quantity",
      required: true,
      label: "Request Quantity",
      placeholder: "Enter Quantity",
      type: "text",
      gridClass: "col-lg-3",
      validation: {
        required: true,
        // Only positive integers, no decimals, no leading zeros
        pattern: /^[1-9][0-9]*$/,
        message: "Quantity must be a whole positive number",
      },
    },
    {
      name: "po_expected_date",
      label: "Expected Date",
      required: true,
      placeholder: "",
      type: "date",
      gridClass: "col-lg-3",
      minDate: new Date(),
      // validation
      validation: { required: true },
    },
  ];

  useEffect(() => {
    console.log(selectedVariantId, "selectedVariantId");

    setFormData((prevData) => ({
      ...prevData,
      item_name: selectedVariantId?.finalproductName,
      item_category_name: selectedVariantId?.part_category_name,
      variant: selectedVariantId?.variant_id,
      model_name: selectedVariantId?.model_name,
      color: selectedVariantId?.color_name,
      // warranty:selectedVariantId?.warranty,
    }));
  }, [showModal, selectedVariantId]);

  const sliderSettings = (imagesCount) => ({
    dots: true,
    infinite: imagesCount > 1, // Disable infinite loop if only one image
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
  });

  // Slider settings
  // const sliderSettings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   // autoplay: true,  // Enables autoplay
  //   // autoplaySpeed: 1000, // Slide will change every 3 seconds (3000 ms)
  //   // pauseOnHover: true, // Pauses the slider when hovering over the images
  // };
  useEffect(() => {
    setFormData({ ...formData, podate: Date.now(), status: "Pending" });
  }, []);

  console.log(orders, "orders");

  return (
    <div className="row order-container-row-scroller">
      {orders && orders.length > 0 ? (
        <>
          {orders.slice(0, visibleOrders).map((order, index) => (
            <div
              className="col-md-6 mt-3"
              key={order.variant_id || index}
              id={index === visibleOrders - 1 ? "last-order" : ""}
            >
              <div className="order-item">
                <div className="order-image-slider">
                  <Slider {...sliderSettings(order?.variant_images?.length)}>
                    {order?.variant_images?.map((image, idx) => (
                      <div key={idx}>
                        <img
                          src={image}
                          height={200}
                          style={{ width: "100%", objectFit: "contain" }}
                          alt={`Variant ${idx + 1}`}
                          className="order-image"
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="order-details">
                  <h3>{order.finalproductName}</h3>
                  {order?.itemtype === "V" ? (
                    <>
                      <p>
                        Make: {order.make_name} | Model: {order.model_name}
                      </p>
                      <p>
                        Color: {order.color_name} | Product Type:{" "}
                        {order.product_name}
                      </p>
                      <p>Stock Quantity: {order.item_quantity || 0}</p>
                      {/* <p>Remark: {order.remark || "--"}</p> */}
                      {/* <p>
                        Type: <span>FG</span>
                      </p> */}
                    </>
                  ) : (
                    <>
                      <p>Model: {order.model_name || "--"}</p>
                      <p>Type: {order.itemtypename}</p>
                      <p>Color: {order.color_name} </p>
                      <p>Stock Quantity: {order.item_quantity || 0}</p>
                    </>
                  )}
                  {/* <p className="productprice">
                    Price: {order.exshowroom_price}{" "}
                    {order?.remark ? `( ${order.remark} )` : ""}
                  </p> */}
                  <div className="order-actions">
                    {/* <button
                      className="order-now"
                      onClick={() => handleOrderNowClick(order)}
                    >
                      Order Now
                    </button> */}
                    {/* item_quantity */}

                    <a
                      href={order?.product_brochure}
                      target="_blank"
                      className="view-voucher"
                    >
                      View Brochure
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Loader appears while fetching more orders */}
          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="col-12 text-center mt-3"
            >
              <OrderCardLoader />
            </div>
          )}
        </>
      ) : (
        <p>No products found.</p>
      )}

      {showModal && (
        <div className="custom-modal-overlay-orderCard">
          <div className="custom-modal-orderCard">
            <div className="custom-modal-header-orderCard">
              <h6 style={{ fontSize: "19px", fontWeight: "600" }}>
                Order Details
              </h6>
              <button
                style={{ fontSize: "28px", fontWeight: "600" }}
                className="close-button"
                onClick={handleModalClose}
              >
                ×
              </button>
            </div>
            <div className="custom-modal-body-orderCard">
              {/* Dynamic Form */}
              <DynamicForm
                formConfig={VariantInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />

              {/* Buttons */}
              <div className="btn-wrapper mt-3">
                <button
                  className="submit-btn"
                  onClick={() => handleDraft(formData)}
                >
                  Add to Draft
                </button>
                <button
                  className="submit-btn"
                  onClick={() => handleSubmit(formData)}
                >
                  Send Order
                </button>
                <button className="cancel-btn" onClick={handleModalClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderCard;
